<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/logo-only.svg">
                </div>
            </div>

            <div style="font-size: 8pt; margin-left: 10px;">
                <!--<fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>-->
                <!-- <span style="font-size: 12pt; ">{{_toolbarService.origem}} » </span>
                <span style="font-size: 12pt; ">{{_toolbarService.pagina}}</span> -->
            </div>
            
        </div>

        <div fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-flat-button class="btn-lara-ia" (click)="laraIA()" matTooltip="Lara IA">
                <img src="assets/images/imgs-lara/lara.png" class="icon-lara" alt="Lara IA">
            </button>


            <button mat-icon-button (click)="notification()" matTooltip="Notificações"
                [matBadge]="(qtdNotificacoes$ | async) > 0 ? ((qtdNotificacoes$ | async) > 99 ? '99+' : (qtdNotificacoes$ | async)) : ''" matBadgeColor="warn" style="margin-left: 20px;">
                <mat-icon>notifications_none</mat-icon>
            </button>

            <button mat-button [matMenuTriggerFor]="userMenu"
                    class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <span class="username mr-12" fxHide fxShow.gt-sm>{{ user.userDetails ? user.userDetails.firstName : ''  }} {{ user.userDetails ? user.userDetails.lastName : '' }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item sty style="text-align: center;">
                    <span style="line-height: 18px;font-size: 15px;">
                        <span fxLayout="row">Função</span>
                        <span fxLayout="row" style="font-weight: bold;">{{ funcao }}</span>
                    </span>
                </button>

                <button mat-menu-item sty style="text-align: center;">
                    <span style="line-height: 18px;font-size: 15px;">
                        <span fxLayout="row" style="font-weight: bold;">Versão {{ versaoPlataforma }}</span>
                    </span>
                </button>

                <button mat-menu-item (click)="meuPerfil()">
                    <mat-icon>account_circle</mat-icon>
                    <span>Meu Perfil</span>
                </button>

                <button mat-menu-item class="" (click)="changeTheme()">
                    <mat-icon>invert_colors</mat-icon>
                    <span>{{this.theme}}</span>
                </button>

                <button mat-menu-item class="" (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Sair</span>
                </button>

            </mat-menu>

            <div class="toolbar-separator"></div>

            <!--<fuse-search-bar (input)="search($event)"></fuse-search-bar>-->

            <div class="toolbar-separator"></div>

            <!--<button mat-button fxHide fxShow.gt-xs
                    class="language-button"
                    [matMenuTriggerFor]="languageMenu">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
                    <span class="iso text-uppercase">{{selectedLanguage.id}}</span>
                </div>
            </button>

            <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
                    <span fxLayout="row" fxLayoutAlign="start center">
                        <img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
                        <span class="iso">{{lang.title}}</span>
                    </span>
                </button>

                <button mat-menu-item [routerLink]="'/components/multi-language'">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <span>Learn more</span>
                    </div>
                </button>

            </mat-menu>-->

            <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

            <!--<button mat-icon-button fxHide.gt-md
                    class="chat-panel-toggle-button"
                    (click)="toggleSidebarOpen('chatPanel')"
                    aria-label="Toggle chat panel">
                <mat-icon class="secondary-text">chat</mat-icon>
            </button>-->

            <div class="toolbar-separator" fxHide.gt-md></div>

            <!--<button mat-icon-button
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                <mat-icon class="secondary-text">format_list_bulleted</mat-icon>
            </button>-->

            <!--<div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

            <button mat-icon-button class="navbar-toggle-button"
                    *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>-->

        </div>

    </div>

</mat-toolbar>
